(ns dashboard.interceptors
  (:require
   [re-frame.core :refer [after path debug trim-v inject-cofx]]
   [dashboard.db :refer [settings->local-store]]))

;;-------------------------
;; Interceptors

;; Event handlers change state, that's their job. But what happens if there's
;; a bug which corrupts app state in some subtle way? This interceptor
;; is run after each event handler has finished, and it checks app-db
;; against a spec.  This helps us detect event handler bugs early

(def standard-interceptors
  [(when ^boolean js/goog.DEBUG debug)
   (inject-cofx :now)
   trim-v])

;; This interceptor stores settings into local storage
;; we attach it to each event handler which could update settings
(def ->local-store (after settings->local-store))
